import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.75 15.402a2 2 0 0 1 .436-1.68l3.316-3.915-4.794-.539a2 2 0 0 1-1.607-1.183L12 3.303 9.9 8.085a2 2 0 0 1-1.608 1.183l-4.794.539 3.316 3.914a2 2 0 0 1 .437 1.68l-1.107 5.6 4.876-2.74a2 2 0 0 1 1.96 0L17.856 21l-1.107-5.6Zm1.326 6.711ZM15.932 7.281l-2.592-5.9A1.466 1.466 0 0 0 12 .5c-.58 0-1.105.345-1.34.881l-2.592 5.9-5.763.647a1.47 1.47 0 0 0-1.203.93c-.2.512-.103 1.093.251 1.51l3.935 4.646-1.326 6.711a1.493 1.493 0 0 0 .573 1.49c.462.34 1.078.38 1.577.098L12 20.003l5.888 3.31c.5.281 1.115.243 1.577-.098.462-.341.685-.923.573-1.49l-1.326-6.711 3.935-4.645c.354-.418.45-.999.25-1.51a1.47 1.47 0 0 0-1.202-.93l-5.763-.648Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconToggleStarOff24 = createIcon(IconComponent);